import { FiChevronDown } from "react-icons/fi";
import { forwardRef } from "react";

const FilterDropdown = forwardRef(
  ({ label, options, value, onChange, isOpen, onToggle }, ref) => {
    return (
      <div ref={ref} className="relative">
        <button
          onClick={onToggle}
          className={`inline-flex items-center px-2 py-1 text-sm md:text-base font-medium rounded-md transition
            ${
              isOpen
                ? "ring-2 ring-blue-500 text-primary"
                : "text-gray-700 hover:bg-gray-100"
            } 
            focus:outline-none`}
        >
          {value ? options.find((opt) => opt.value === value)?.label : label}
          <FiChevronDown
            className={`w-5 h-5 ml-2 transform transition-transform duration-200 ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
          />
        </button>

        <div
          className={`absolute z-50 mt-2 min-w-full md:w-48 bg-white divide-y divide-gray-100 rounded-lg shadow transition-all duration-200 origin-top ${
            isOpen
              ? "opacity-100 scale-100 pointer-events-auto"
              : "opacity-0 scale-95 pointer-events-none"
          } max-h-60 overflow-auto`}
        >
          <ul className="py-2 text-base text-gray-700">
            {options.map((opt) => (
              <li key={opt.value}>
                <button
                  className={`w-full px-4 py-2 text-left hover:bg-gray-100 ${
                    value === opt.value ? "bg-gray-100 font-medium" : ""
                  }`}
                  onClick={() => {
                    onChange(opt.value);
                  }}
                >
                  {opt.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
);

export default FilterDropdown;
